module.exports = __webpack_public_path__ + "img/no-size-info.5fc9f9a5.png";